const PERMISSION_KEY= "personalize:nebula_user_profile_history";
const PAGE_URL = {
    NEBULA_USER_PROFILE_HISTORY_PAGE: "/admin/personalize/nebula-user-profile-history"
}

export {PERMISSION_KEY, PAGE_URL}

